import Text from '../../../../../typography';
import styled from 'styled-components';

export const HelpText = styled(Text)`
  padding: 0 8px;
  color: ${({ theme }) => theme.color.tint.secondary};
`;

export const FormFooterSC = styled.div`
  padding-left: 8px;
  margin-top: 4px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;
